// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1ZBJN","colCheckbox":"styles_colCheckbox__2m0Ny"};